var map = {
	"./1-jul12dec12.pdf": 61,
	"./10-oct16mar17.pdf": 62,
	"./11-apr17sep17.pdf": 63,
	"./12-oct17mar18.pdf": 64,
	"./13-apr17dec18.pdf": 65,
	"./14-jan19jun19.pdf": 66,
	"./15-jul19dec19.pdf": 67,
	"./16-jul31dec20.pdf": 68,
	"./17-jan21jun21.pdf": 69,
	"./18-apr23jun23.pdf": 70,
	"./19-jul23sep23.pdf": 71,
	"./2-apr13sep13.pdf": 72,
	"./20-oct23dec23.pdf": 73,
	"./21-jan24jan24.pdf": 74,
	"./22-jan25jun25.pdf": 75,
	"./23-apr25sep25.pdf": 76,
	"./3-oct13mar14.pdf": 77,
	"./4-apr14sep14.pdf": 78,
	"./5-oct14dec14.pdf": 79,
	"./6-jan15june15.pdf": 80,
	"./7-jul15dec15.pdf": 81,
	"./8-jan16march16.pdf": 82,
	"./9-apr16sep16.pdf": 83
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25;